<template>
  <p class="component-heading">GRN</p>
  <b-row>
    <b-col lg="6" md="6" sm="12">
      <div class="field mt-1">
        <TextField name="GRN Number" label="GRN Number" id="GRN Number" v-model="GRNForm.refNo" :required-icon="true"
          :rules="{ required: true, alphanumeric: true }" />
      </div>
    </b-col>
    <b-col lg="6" md="6" sm="12">
      <div class="field mt-5">
        <Datepicker label="GRN Date" id="GRN Date" v-model="GRNForm.docDate" name="GRN Date" :required-icon="true"
          :rules="{ required: true }" />
      </div>
    </b-col>
  </b-row>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, reactive } from "vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import Dropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Datepicker from "../../../../../components/FormComponents/DatePicker.vue";
import common from "../../../Service/CommonService";
import AutoComplete from "../../../../../components/FormComponents/AutoComplete.vue";
import service from "../../../Service/SupplierMaster";
export default defineComponent({
  props: {
    showone: {
      type: String,
      default: "",
    },
  },
  components: {
    TextField,
    Dropdown,
    Datepicker,
    AutoComplete,
  },
  setup(props, { emit }) {
    onMounted(() => {
      input();
      suppliercategorydd();
    });
    var supcategory = ref();

    let GRNForm = reactive({
      refNo: "",
      docDate: "",
      supcategory: "",
    });
    async function suppliercategorydd() {
      try {
        const dataresponse = await service.gettable();

        console.log(dataresponse);

        supcategory.value = dataresponse["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }
    function input() {
      debugger;
      console.log(GRNForm);
      emit("update:modelValue", GRNForm);
    }
    return {
      GRNForm,
      supcategory,
    };
  },
});
</script>
